import {User} from "../../../../api/accessControl/User.ts";
import Insights from "../Insights.tsx";
import Shell from "../../../../components/specific/Shell.tsx";

export default function InsightsPage({currentUser}: { currentUser: User }) {
    return (
        <Shell currentUser={currentUser} title="Insights">
            <Insights currentUser={currentUser}></Insights>
        </Shell>
    )
}
